import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { PasswordRuleResult } from 'src/app/models/passwordPolicy.model';
import { evaluatePasswordRules } from 'src/app/shared/utils/password-policy.util';

@Component({
    standalone: false,
    selector: 'app-password-criteria',
    templateUrl: './password-criteria.component.html',
    styleUrls: ['./password-criteria.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordCriteriaComponent implements OnChanges {
    @Input() password = '';

    rules: PasswordRuleResult[] = evaluatePasswordRules('');

    ngOnChanges(): void {
        this.rules = evaluatePasswordRules(this.password ?? '');
    }
}
